(function ($) {

    $('.room-types-carousel').flickity({
        cellSelector: '.cell-room-types-carousel',
        cellAlign: 'left',
        draggable: false,
        freeScroll: false,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: false,
        fade: true,
        selectedAttraction: 0.125,
    });

    $('.image-content-carousel').flickity({
        cellSelector: '.image-content-item-carousel',
        cellAlign: 'left',
        draggable: false, 
        freeScroll: false,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: true,
        autoPlay: false,
    });

    $('.arrow-left-decoration').click(function(event) {
        event.preventDefault();
        $item = this.getAttribute('data-item');
        $('.flickity-button.previous[data-item='+$item+']').click();
    }); 

    $('.arrow-right-decoration').click(function(event) {
        event.preventDefault();
        $item = this.getAttribute('data-item');
        $('.flickity-button.next[data-item='+$item+']').click();
    });

    var $carousel = $('.room-types-carousel');
    $('.filter-room-type').on('click', function() {
        $index = this.getAttribute('data-index');
        $selected = '[data-index='+$index+']';
        $carousel.flickity( 'select', $index);
        $('.filter-room-type').removeClass('is-active');
        $($selected).addClass('is-active');
    });

    var $carouselitem = $('.image-content-carousel');
    $carouselitem.on( 'change.flickity', function( event, index ) {
       $seq = index+1;
       $attr = this.getAttribute('data-item');
       $(".sequence-small-flickity[data-item="+$attr+"]")[0].innerText = $seq;
       $(".sequence-medium-flickity[data-item="+$attr+"]")[0].innerText = $seq;
    });

    $(window).on("load", function() {
        var itemSequene = 0;
        $(".image-content-carousel").children().each(function(){
          var str = this.className;
          if (str.includes("flickity-viewport")) {
            itemSequene += 1;
          }
          if (str.includes("flickity-button")) {
            this.setAttribute("data-item", "item-" + itemSequene);
          }
        });
    })

    
})(jQuery);
